/* eslint-disable import/no-unresolved */
import React, { useEffect, useRef } from "react"
import styled from "styled-components"
import tw from "twin.macro"

import { Social } from "@components"
import { Aeroplane } from "@components/icons"
import { ButtonPrimary } from "@templates"
import scrollReveal from "@utils/scroll.reveal"
import { srConfig, email, colors } from "@config"

const StyledContact = styled.section`
  ${tw`min-h-full text-suvaGrey flex flex-col justify-center px-8 relative pt-12 pb-28`}

  & {
    footer {
      ${tw`md:absolute md:bottom-0 md:inset-x-0 pt-10 md:px-8`}

      .credits {
        ${tw`flex flex-col justify-between gap-2 text-xs py-2 md:gap-5 md:flex-row md:items-center`}
        p {
          ${tw`m-0 flex gap-2`}

          a {
            ${tw`text-deepSky`}
          }
        }
      }
    }
  }
`

const Contact = () => {
  const revealContainer = useRef(null)
  useEffect(() => scrollReveal.reveal(revealContainer.current, srConfig()), [])

  return (
    <StyledContact id="contact" ref={revealContainer}>
      <p>Seems like we have reach the end. What's next?</p>
      <h1 tw="text-4xl text-neutralLight my-0">Let's Connect</h1>
      <div>
        <p tw="md:w-8/12 my-6">
          Whether you want to collaborate on some exciting projects or planning
          to hire, just contact me. Apart from this you can always drop by in my
          inbox if you want to have a nice chat on anime/manga.
        </p>
        <p>
          My Email: <span tw="text-deepSky">{email}</span>
        </p>
        <div tw="mt-8">
          <ButtonPrimary color={colors.amaranth} hover="pink">
            <a className="email-link" href={`mailto:${email}`}>
              <span>Get in touch</span>
              <Aeroplane />
            </a>
          </ButtonPrimary>
        </div>
      </div>
      <footer className="footer" tw="mt-8 md:flex md:justify-between">
        <Social position="contact" />
        <div className="credits">
          <p>
            Design & Developed by:
            <a
              href="https://github.com/keiken-shin/"
              target="_blank"
              rel="noopener noreferrer"
              tw="text-red-400"
            >
              @keiken-shin
            </a>
          </p>

          <p>
            Inspired by:
            <a
              href="https://brittanychiang.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Brittany Chiang
            </a>
          </p>
        </div>
      </footer>
    </StyledContact>
  )
}

export default Contact
